"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PasswordResetForm_1 = require("./PasswordResetForm");
exports.PasswordRestForm = PasswordResetForm_1.default;
//# sourceMappingURL=index.js.map